import Currency from '@modules/Currency.js'
import { useToast } from 'vue-toast-notification'
const $toast = useToast()
import { useStore } from '@stores/Portal/store.js'
import { fetchJson, fetchPost } from '../../../fetch.js'

export default {
    getBasket() {
        this.getBasketRequest()

        fetchJson({
            url: `/basket/fetch`,
        }).then(response => {
            if (response.ok) {
                response.json().then(json => {
                    this.getBasketRequestSuccess(json)

                    if (json.basket.promo) {
                        this.getPromoAppliedSuccess(json.basket.promo)
                    }

                    if (json.basket.promo.promo_set_invalid) {
                        this.updatePromoValidated(false)
                        this.updatePromoMessaging(json)
                    }

                }).catch(err => {
                    this.getBasketRequestFailure(err)
                })
            }
        }).catch(err => {
            this.getBasketRequestFailure(err)
        })
    },

    toggleDoSubscribe(basketItem) {
        if (basketItem.basket_item_id) { // Must have basket_item_id to complete this action
            fetchPost({
                url: `/basket/set-subscribe/${ basketItem.basket_item_id }`,
                body: {
                    do_subscribe: basketItem.do_subscribe
                }
            }).then(response => {
                if (response.ok) {
                    response.json().then(json => {
                        this.toggleDoSubscribeRequestSuccess({
                            json
                        })
                    })
                }
            })
        }
    },

    toggleAllSubscribed() {
        fetchPost({ url: '/api/basket/toggle-subscribe-all' })
            .then(response => {
                if (response.ok) {
                    response.json().then(json => {
                        this.updateBasketOrderDetailsRequestSuccess(json)
                    })
                    .catch(err => {
                        this.updateBasketOrderDetailsRequestFailed(err)
                    })
                }
            })
            .catch(err => {
                this.updateBasketOrderDetailsRequestFailed(err)
            })
    },

    async deleteItem(item) {
        let urlParam = item.id;

        if (item.hasOwnProperty('item')) {
            urlParam = String(`${ item.item_type }_${ item.item_id }`).replace(/\\/g, '-')
        }

        // Deletes item before we even send request (will return if there's an error)
        this.deleteItemRequest(item)
        fetchJson({
            url: `/basket/delete/${urlParam}`,
        }).then(response => {
            if (response.ok) {
                response.json().then(json => {
                    this.deleteItemRequestSuccess(json)
                })
                .catch(err => {
                    this.deleteItemRequestFailure(err)
                })
            }
        })
        .catch(err => {
            this.deleteItemRequestFailure(err)
        })
    },

    async moveBasketItemToSavedBasket(item) {
        let urlParam = item.id;

        if (item.hasOwnProperty('item')) {
            urlParam = String(`${ item.item_type }_${ item.item_id }`).replace(/\\/g, '-')
        }

        // Deletes item before we even send request (will return if there's an error)
        this.deleteItemRequest(item)

        fetchJson({
            url: `/basket/move-basket-item-to-saved-basket/${urlParam}`,
        }).then(response => {
            if (response.ok) {
                response.json().then(json => {
                    this.deleteItemRequestSuccess(json)
                  //  dispatch('user/getUser', null, { root: true })
                })
                    .catch(err => {
                        this.deleteItemRequestFailure(err)
                    })
            }
        })
            .catch(err => {
                this.deleteItemRequestFailure(err)
            })
    },

    async moveSavedItemToBasket(item) {
        let urlParam = item.saved_basket_id;
        this.deleteSavedBasketItemRequest(item)

        fetchJson({
            url: `/basket/move-saved-item-to-basket/${urlParam}`,
        }).then(response => {
            if (response.ok) {
                response.json().then(json => {
                    this.getBasketRequestSuccess(json)
                    //  dispatch('user/getUser', null, { root: true })
                })
                    .catch(err => {
                        this.getBasketRequestFailure(err)
                    })
            }
        })
            .catch(err => {
                this.getBasketRequestFailure(err)
            })
    },

    async deleteSavedBasketItem(item) {
        let urlParam = item.saved_basket_id;
        this.deleteSavedBasketItemRequest(item)

        fetchJson({
            url: `/basket/delete-saved-basket-item/${urlParam}`,
        }).then(response => {
            if (response.ok) {
                response.json().then(json => {
                    this.getBasketRequestSuccess(json)
                })
                    .catch(err => {
                        this.getBasketRequestFailure(err)
                    })
            }
        })
            .catch(err => {
                this.getBasketRequestFailure(err)
            })
    },

    /**
     * Updates the basket record for the current user, making sure the PO and Other fields are stored
     * happens 'on change' or 'onInput' of the text input value.
     */
    updateBasketOrderDetails() {
        this.updateBasketAbortController.abort('Debounce')
        this.updateBasketAbortController = new AbortController()

        fetchPost({
            url: '/api/basket/update',
            body: {
                basket: this.basket,
                subscription: this.subscription
            },
            signal: this
                .updateBasketAbortController
                .signal
        })
            .then(response => {
                if (response.ok) {
                    response.json().then(json => {
                        this.updateBasketOrderDetailsRequestSuccess(json)
                    })
                    .catch(err => {
                        this.updateBasketOrderDetailsRequestFailed(err)
                    })
                }
            })
            .catch(err => {
                this.updateBasketOrderDetailsRequestFailed(err)
            })
    },

    /**
     * Validates the promo code and applies promo_id to basket if valid.
     */
    checkPromoCode() {
        this.updatePromoCodeInput(this.promo.promoCode)

        fetchPost({
            url: `/api/promo`,
            body: {
                'code': this.promo.promoCode
            }
        })
            .then(response => {
                if (response.ok) {
                    response.json().then(json => {
                        if (json.basket && json.basket.promo) {
                            this.getPromoAppliedSuccess(json.basket.promo)
                            this.getBasket()
                            this.getBasketRequestSuccess(json)
                        }


                        if (json.promo_notification) {
                            this.promoNotification(json)
                        }

                        if (json.type === 'error') {
                            if (json.promo_invalid) {
                                this.getBasketRequestSuccess(json)
                            }

                            this.updatePromoValidated(false)
                            this.updatePromoMessaging(json)
                        }
                    })
                        .catch(err => {
                            console.log(err)
                        })
                }
            })
            .catch(err => {
                console.log(err)
            })
    },

    /**
     * Removes the promo id from the basket.
     */
    removePromoCode() {
        this.updateIsSubmitting(true)

        if (! this.basket.promo) {
            return this.resetPromoState()
        }

        fetchPost({
            url: `/api/promo/${this.promo.promoCode}/remove`,
            // body: this.basket
        })
            .then(response => {
                if (response.ok) {
                    response.json().then(json => {
                        this.getBasketRequestSuccess(json)
                        this.resetPromoState()
                    })
                        .catch(err => {
                            console.log(err)
                        })
                }
            })
            .catch(err => {
                console.log(err)
            })
    },

    doSetCardId(cardId) {
        this.setCardId(cardId)
        this.updateBasketOrderDetails()
    },

    // MUTATIONS
    getBasketRequest() {
        this.isLoading = true
    },

    getBasketRequestSuccess(data) {
        this.isLoading = false
        Object.assign(
            this.basket,
            data.basket
        )

         useStore().setPageIsLoading(false)
    },

    getBasketRequestFailure(err) {
        this.isLoading = false
        // console.error({ err })
    },

    deleteItemRequest(item) {
        this.basket.basket_items.splice(
            this.basket.basket_items.findIndex(basketItem => (
                basketItem.id === item.id
            )),
            1
        )
    },

    deleteItemRequestSuccess(data) {
        Object.assign(
            this.basket,
            data
        )

        if (data.feedback) {
            $toast.open({
                message: data.feedback.message,
                type: data.feedback.type,
            });
        }
    },

    deleteItemRequestFailure(err) {
        // console.error({ err })
    },

    updateBasketOrderDetailsRequestSuccess(data) {
        Object.assign(
            this,
            data
        )
    },

    updateBasketOrderDetailsRequestFailed() {
        // this.$toast.open({
        //     message: "<div class='v-toast__text'><h3>Sorry there was an error updating your details.</h3><p>Please try again and contact Customer Services if you see this message again</p></div>",
        //     type: 'error',
        //     duration: 0
        // });
    },

    setBasket(basket) {
        if (this.basket.has_free_delivery !== undefined) {
            if (
                ! this.basket.has_free_delivery
                && basket.has_free_delivery
                && basket.basket_items.length > 0
            ) {
                $toast.success(
                    "Congratulations.<br /> You have now qualified for free delivery"
                )
            }

            if (
                this.basket.has_free_delivery
                && ! basket.has_free_delivery
            ) {
                $toast.warning(
                    'Spend another ' + Currency.format(basket.delivery_upsell) + ' to get free delivery.'
                )
            }
        }

        Object.assign(this.basket, basket)
        Object.assign(this.promo, basket.promo)

        if (basket.promo.promo_set_invalid) {
            $toast.open({
                message: basket.promo.status.message,
                type: 'error',
                duration: 5000
            });
        }

    },

    /* PROMO RELATED*/
    getPromoAppliedSuccess(data) {
        Object.assign(this.promo, data)
        this.isSubmitting = false

        if (data.notification) {
            $toast.open({
                message: data.notification,
                type: 'success',
                duration: 5000
            });
        }
    },

    promoNotification(data) {
        if (data.promo_notification) {
            $toast.open({
                message: data.promo_notification,
                type: 'success',
                duration: 5000
            });
        }
    },

    updatePromoCodeInput(data) {
        this.isSubmitting = true
        this.promo.promoCode = data
    },

    updatePromoValidated(boolean) {
        this.isSubmitting = false
        this.promo.validated = boolean;
    },

    setCardId(card_id) {
        this.basket.card_id = card_id
    },

    updatePromoMessaging(data) {
        Object.assign(this.promo.status, data)

        if (data.basket && data.basket.promo.promo_set_invalid) {
            $toast.open({
                message: data.basket.promo.status.message,
                type: 'error',
                duration: 5000
            });
        }
    },

    resetPromoState() {
        this.isSubmitting = false
        Object.assign(this.promo, {
            promoCode: '',
            validated: false,
            status: {
                type: '',
                message: '',
            }
        })
    },

    updateIsSubmitting(boolean) {
        this.isSubmitting = boolean
    },

    deleteSavedBasketItemRequest(item) {
         useStore().setPageIsLoading(true)

        this.basket.user.saved_basket_items.splice(
            this.basket.user.saved_basket_items.findIndex(savedBasketItem => (
                savedBasketItem.saved_basket_id === item.saved_basket_id
            )),
            1
        )
    },

    toggleDoSubscribeRequestSuccess({ json }) {
        Object.assign(
            this.basket.unformatted_totals,
            json.unformatted_totals
        )

        this.basket.all_items_subscribed = json.all_items_subscribed
      
        this.basket.do_subscribe = json.do_subscribe
    },




    // Functional stuff
    // This function takes a product id and adds to the basket (returns a promise)
    addProductVariant(productVariantId, crossSellGTMPromotionId, quantity = 1) {
        const qtyParam = quantity > 1 ? `&qty=${encodeURIComponent(quantity)}` : ''
        return new Promise((resolve, reject) => {
            fetchJson({
                url: `/api/basket/${productVariantId}/add?gtm_id=${ crossSellGTMPromotionId }${qtyParam}`,
                method: 'GET'
            }).then(response => {
                if (response.ok) {
                    response.json().then(json => {
                        this.getBasket()
                        return resolve(json)
                    })
                } else {
                    return reject()
                }
            }).catch(() => reject())
        })
    }
}
